// Leaflet accepts a line or separate lines. Keep parts separate in every other consumer too.
const point = (p) => Array.isArray(p) && p.length === 2 && p.every(Number.isFinite);

export function routeLines(geometry) {
  if (!Array.isArray(geometry) || !geometry.length) return [];
  const lines = point(geometry[0]) ? [geometry] : geometry;
  return lines.filter((line) => Array.isArray(line) && line.length >= 2 && line.every(point));
}

export function routeVertices(geometry) {
  return routeLines(geometry).flat();
}

export function routeTool(geometry) {
  const parts = routeLines(geometry);
  return { parts, partIndex: 0, coords: parts[0] ?? [] };
}

export function editingParts(tool) {
  const parts = [...(tool.parts?.length ? tool.parts : [tool.coords])];
  parts[tool.partIndex ?? 0] = tool.coords;
  return parts;
}

export function selectPart(tool, index) {
  const parts = editingParts(tool);
  return { ...tool, parts, partIndex: index, coords: parts[index] ?? [] };
}

export function addPart(tool) {
  const parts = [...editingParts(tool), []];
  return { ...tool, parts, partIndex: parts.length - 1, coords: [] };
}

export function drawnGeometry(tool) {
  const lines = editingParts(tool).filter((line) => line.length >= 2);
  return lines.length === 1 ? lines[0] : lines;
}
